import React, { useState } from "react";
import {
  Button,
  Flex,
  Table,
  Card,
} from "antd";

import { formatDateISO } from "../../../utils/date";
import OrderDetailModal from "../../psim/shared/orderDetailModal";
import { useGetUsimPendingSubmissionsQuery } from "../../../api/usim/orders/UsimOrdersApi";
import { UsimOrderItemData } from "../../../api/usim/orders/UsimOrderItem";


const BASE_COLUMNS = ["orderProcessedDate", "OrderNumber", "type", "sku", "iccid", "mobileNumber", "status", "activationDate", "action"];
const COLUMNS_STORAGE_KEY = "usimPendingActivationTableColumns";

export default function UsimManageOrderPage() {
  const [selectedOrder, setSelectedOrder] = useState<UsimOrderItemData | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState<Record<string, string[]>>({});

  const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem(COLUMNS_STORAGE_KEY);
      return saved ? JSON.parse(saved) : BASE_COLUMNS;
    } catch (e) {
      return BASE_COLUMNS;
    }
  });

  const { data: tableData = [], error, isLoading, refetch } = useGetUsimPendingSubmissionsQuery("");

  const showDetailsModal = (order: UsimOrderItemData) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedOrder(null);
  };

  const allColumns = [
    {
      title: "Order Number",
      dataIndex: "OrderNumber",
      key: "OrderNumber",
      render: (text: string, record: UsimOrderItemData) => 
        record.status?.toUpperCase() === 'CANCELLED' ? (
          <div style={{ backgroundColor: 'red', color: 'white', padding: '4px', borderRadius: '4px' }}>
            {record.OrderNumber || "-"}
          </div>
        ) : record.OrderNumber || "-"
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
    },
      {
      title: "Submitted At",
      dataIndex: "orderProcessedDate",
      key: "orderProcessedDate",
      render: (text: string, record: UsimOrderItemData) => 
        record.orderProcessedDate ? formatDateISO(record.orderProcessedDate) : "-",
      sorter: (a: UsimOrderItemData, b: UsimOrderItemData) => a.orderProcessedDate.localeCompare(b.orderProcessedDate)
    },
    {
      title: "Activation Date",
      dataIndex: "activationDate",
      key: "activationDate",
      render: (text: string, record: UsimOrderItemData) => 
        record.activationDate ? formatDateISO(record.activationDate) : "-"
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: UsimOrderItemData) => (
        <Button type="primary" onClick={() => showDetailsModal(record)}>
          View
        </Button>
      )
    }
  ];

  const columns = allColumns.filter(col => visibleColumns.includes(col.key as string));

  return (
    <Flex gap={16} vertical >
      <Card
      title="Usim Pending Submission"
      style={{ width: "100%", height: "100%" }}
    >
      <Table
        rowKey={(record : UsimOrderItemData) => record.OrderNumber + (record.shopId || "")}
        columns={columns as any}
        dataSource={Array.isArray(tableData) ? tableData : []}
        loading={isLoading}
        onChange={(pagination, filters) => {
          setFilteredInfo(filters as Record<string, string[]>);
        }}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} orders`
        }}
      />
      </Card>

      {selectedOrder && (
        <OrderDetailModal
          isVisible={isModalVisible}
          orderData={selectedOrder}
          onClose={handleModalClose}
        />
      )}
    </Flex>
  );
}
